module.exports = __webpack_public_path__ + "img/milton.e6248c72.png";